import axios from 'axios'

export default {
  getPlan(query: any = null, per_page = 10) {
    return new Promise((resolve, reject) => {
      let params = {per_page: per_page }
      params = { ...query, ...params };
      axios.get('/cbs/subscription-plans', {
        params: params
      }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      }).finally(() => {
        //
      })
    })
  },

  storePlan(payload: any) {
    return new Promise((resolve, reject) => {
      axios.post('/cbs/subscription-plans', payload)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },

  showPlan (id: any) {
    return new Promise((resolve, reject) => {
      axios.get('/cbs/subscription-plans/' + id)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },

  updatePlan (id: any, payload: any) {
    return new Promise((resolve, reject) => {
      axios.put('/cbs/subscription-plans/' + id, payload)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },

  destroyPlan (id: any) {
    return new Promise((resolve, reject) => {
      axios.delete('/cbs/subscription-plans/' + id)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },

  getUniqueRefIds () {
    return new Promise((resolve, reject) => {
      axios.get('/cbs/subscription-plans/get-unique-ref-ids')
        .then(response => {
          resolve(response.data)
        }).catch(error => {
        reject(error)
      })
    })
  },

  getSubscriptionPlans () {
    return new Promise((resolve, reject) => {
      axios.get('/cbs/subscription-plans/get-subscription-plans')
        .then(response => {
          resolve(response.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
}
